import React from 'react';

export const centsToDollars = (toRound: number, decimal = 2): string =>
  (toRound / 100).toFixed(decimal);

export const formatCents = (cents: number, decimal?: number): string => formatMoney(centsToDollars(cents, decimal));

export const formatMoney = (value: string | number, currency = '$') =>
  currency + value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

export const useFormatMoney = (value: string | number, currency?: string) => {
  return React.useMemo(() => formatMoney(value || 0, currency), [ value, currency ]);
};


export type MoneyProps = {
  value: number | string;
  currency?: string;
};


export const Money: React.FC<MoneyProps> = ({ value, currency = '$' }) => {
  const memoized = useFormatMoney(value, currency);

  // return <span>{memoized}</span>;
  return <span>{memoized}</span>;
};


export const MoneyCents: React.VFC<{ value: number; currency?: string }> = ({ value, currency }) => {
  const _value = value ?? 0;

  return <Money value={centsToDollars(_value)} currency={currency} />;
};
